var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import moment from "moment";
import { Link, Redirect } from "react-router-dom";
import { DayPickerSingleDateController } from "react-dates";
import classNames from "classnames";
import z from "zod";
import { useShallowCompareEffect } from "react-use";
import ContentLayout from "../../Layout/ContentLayout";
import CustomCard from "../../UI/CustomCard/CustomCard";
import { BasicFormFormat } from "../../UI/FormFormat/FormFormat";
import SearchField from "../../Form/SearchField";
import ServiceResult, { Loaders } from "../../UI/ServiceResult/ServiceResult";
import useService from "../../Hooks/useService";
import { ServiceDeliveryLocationMultiSearch } from "../../Presentational/ServiceDeliveryLocation/ServiceDeliveryLocationSearch";
import { ServiceOfferingSearch } from "../../Presentational/ServiceOffering/ServiceOfferingSearch";
import DateService from "../../../Services/Shared/Date.service";
import ListService from "../../../Services/Shared/List.service";
import FAIcon from "../../UI/FAIcon/FAIcon";
import MeetingAvailabilityService from "../../../Services/MeetingAvailability.service";
import DefaultPopover from "../../UI/Popover/DefaultPopover";
import NumberService from "../../../Services/Shared/Number.service";
import Modal from "../../UI/Modal/Modal";
import ModalHeader from "../../UI/Modal/ModalHeader";
import { HierarchicalTableBody } from "../../UI/HierarchicalTableBody/HierarchicalTableBody";
import ProfilePicture from "../../Presentational/Person/ProfilePicture/ProfilePicture";
import InfoItems from "../../UI/InfoItems/InfoItems";
import { MeetingModalityMultiSearch } from "../../Presentational/MeetingModality/MeetingModalitySearch";
import { AlertError, AlertInfo } from "../../UI/StandardAlerts/StandardAlerts";
import A11yHelpers from "../../../../util/A11yHelpers";
import { PersonWithMeetingAvailabilityMultiSearch } from "../../Presentational/Person/PersonWithMeetingAvailabilitySearch";
import PersonService from "../../../Services/Person.service";
import useParams from "../../Hooks/useParams";
import ServiceOfferingService from "../../../Services/ServiceOffering.service";
import { SaveButton } from "../../UI/StandardButtons/StandardButtons";
import { getMeetingsConfirmationPath } from "./MeetingsRoutes";
import CampaignService from "../../../Services/Campaign.service";
import { LocationMultiSearch } from "../../Presentational/Location/LocationSearch";
import AppointmentCampaignInfoDomainService from "../../../Domain/AppointmentCampaignInfo/AppointmentCampaignInfo.service";
import useHistoryState from "../../Hooks/useHistoryState";
import RoleService from "../../../Services/Role.service";
const MEETINGS_SCHEDULE_SEARCH_PARAMS = z.object({
    serviceId: z.coerce.number().optional(),
    // personId
    staffId: z.string().uuid().optional(),
    officeId: z.coerce.number().optional(),
    modalityId: z.coerce.number().optional(),
    locationId: z.coerce.number().optional(),
    // affiliationId, this is provided through the Meetings Tab UI and will be used in the confirmation page
    studentId: z.string().uuid().optional(),
    campaignId: z.coerce.number().optional(),
});
const MeetingSchedulerCalendar = ({ value, onChange, roundDateTo = "startOfDay", highlightedDates, onMonthChange, }) => {
    const [isDateFocused, setIsDateFocused] = React.useState(false);
    const isHighlighted = (day) => {
        return highlightedDates.some((highlightedDate) => day.isSame(highlightedDate, "day"));
    };
    const isBlocked = (day) => {
        return !highlightedDates.some((highlightedDate) => day.isSame(highlightedDate, "day"));
    };
    const isDayHighlighted = (day) => {
        return isHighlighted(day) && !isBlocked(day);
    };
    const isDayBlocked = (day) => {
        return !isHighlighted(day) && isBlocked(day);
    };
    const CustomDatePickerContents = (day) => {
        const isToday = isDayHighlighted(day);
        return (_jsxs(_Fragment, { children: [day.format("D"), isToday && (_jsx("div", { className: "w-100 position-relative", children: _jsx(FAIcon, { icon: "circle", type: "fas", className: classNames("w-100 date-circle"), style: {
                            position: "absolute",
                            fontSize: "0.5rem",
                            left: 0,
                            bottom: -5,
                        } }) }))] }));
    };
    return (_jsx("div", { className: "meeting-scheduler", children: _jsx(DayPickerSingleDateController, { date: value, onNextMonthClick: (mom) => {
                onMonthChange(mom.month() + 1, mom.year());
            }, onPrevMonthClick: (mom) => {
                onMonthChange(mom.month() + 1, mom.year());
            }, onDateChange: (newDate) => {
                var _a, _b;
                if (!newDate) {
                    return onChange(null);
                }
                switch (roundDateTo) {
                    case "startOfDay":
                        return onChange((_a = moment(newDate)) === null || _a === void 0 ? void 0 : _a.startOf("day"));
                    case "endOfDay":
                        return onChange((_b = moment(newDate)) === null || _b === void 0 ? void 0 : _b.endOf("day"));
                    default:
                        return onChange(moment(newDate));
                }
            }, focused: isDateFocused !== null && isDateFocused !== void 0 ? isDateFocused : false, onFocusChange: ({ focused }) => setIsDateFocused(focused), numberOfMonths: 1, isDayBlocked: isDayBlocked, initialVisibleMonth: () => value !== null && value !== void 0 ? value : moment(new Date()), renderDayContents: CustomDatePickerContents, hideKeyboardShortcutsPanel: true }) }));
};
// Grab all params from the url and parse them into matching values for the form state
const parseSearchParamsToDefaultValues = (meetingsScheduleParams) => __awaiter(void 0, void 0, void 0, function* () {
    const { staffId, serviceId } = meetingsScheduleParams;
    const [service, staff] = yield Promise.all([
        serviceId ? ServiceOfferingService.get(serviceId) : null,
        staffId
            ? PersonService.searchWithMeetingAvailability({
                ids: [staffId],
            })
            : null,
    ]);
    return {
        offering: service,
        staff,
        locations: null,
        offices: null,
        modalities: null,
    };
});
const MeetingDependencyForm = ({ initialDependencies, setDependencyErrorMessage, saveButtonRef, slotsState, isCurrentUserStaff, }) => {
    var _a;
    const { watch, reset, setValue } = useFormContext();
    const staff = watch("staff");
    const offering = watch("offering");
    const offices = watch("offices");
    const campuses = watch("locations");
    const modalities = watch("modalities");
    const currentDependencies = React.useMemo(() => initialDependencies.search({
        people: staff && staff.length ? staff.map((s) => s.personId) : null,
        offerings: (offering === null || offering === void 0 ? void 0 : offering.id) ? [offering.id] : null,
        offices: offices && offices.length ? offices.map((o) => o.id) : null,
        campuses: campuses && campuses.length ? campuses.map((c) => c.id) : null,
        modalities: modalities && modalities.length ? modalities.map((m) => m.id) : null,
    }), [campuses, initialDependencies, modalities, offering === null || offering === void 0 ? void 0 : offering.id, offices, staff]);
    const errorMessage = currentDependencies.isInvalid();
    useEffect(() => {
        setDependencyErrorMessage(errorMessage);
    }, [errorMessage, setDependencyErrorMessage]);
    // Determines if we display staff names by checking if the service allows viewing
    // staff names or if the current user is a staff member. This is so staff
    // members can easily schedule meetings for students and allows staff members
    // to bypass the service staff selection restriction
    const showStaffNames = ((_a = offering === null || offering === void 0 ? void 0 : offering.showStaffNames) !== null && _a !== void 0 ? _a : true) || isCurrentUserStaff;
    return (_jsxs(_Fragment, { children: [_jsx(SearchField, { label: "Service", name: "offering", required: true, as: (provided) => (_createElement(ServiceOfferingSearch, Object.assign({}, provided, { serviceOfferingIdsInclude: currentDependencies.offerings, key: currentDependencies.offerings.join("-"), forceEmptyReturn: !!errorMessage, 
                    // We prompt the user to confirm whether they want to proceed if they pick a service that doesn't allow to select staff names.
                    // If they confirm the action, we update the selected service and clear the staff field
                    // If they cancel it, we set the service back to the value before the selection
                    selectionConfirmation: (newSelection) => {
                        // We need to check for a few scenarios in order to display or not the confirmation modal
                        // The selected service needs to restrict it, the user shouldn't be a staff member
                        // Then we check to see if the staff field is not null (it gets initialized as null)
                        // And if the staff is not an empty array (happens when you clear the field manually)
                        if (newSelection != null &&
                            !newSelection.showStaffNames &&
                            !isCurrentUserStaff &&
                            !ListService.isNullOrEmpty(staff)) {
                            return {
                                message: "Staff for this service are selected randomly and a previous staff selection(s) will be cleared. Are you sure you want to proceed?",
                                // If user decides to proceed, update the state of the current service clear the status field and update the current field
                                onConfirmed: () => {
                                    setValue("staff", []);
                                },
                            };
                        }
                        return null;
                    } }))) }), _jsxs("div", { className: "row", children: [_jsx("div", { className: "col-6", children: _jsx(SearchField, { label: "Campus", name: "locations", as: (provided) => (_createElement(LocationMultiSearch, Object.assign({}, provided, { ids: currentDependencies.campuses, key: currentDependencies.campuses.join("-"), forceEmptyReturn: !!errorMessage }))) }) }), _jsx("div", { className: "col-6", children: _jsx(SearchField, { label: "Office", name: "offices", as: (provided) => (_createElement(ServiceDeliveryLocationMultiSearch, Object.assign({}, provided, { ids: currentDependencies.offices, key: currentDependencies.offices.join("-"), forceEmptyReturn: !!errorMessage, showInNewScheduler: true }))) }) })] }), _jsxs("div", { className: "row", children: [_jsx("div", { className: "col-6", children: _jsx(SearchField, { label: "Staff", name: "staff", as: (provided) => (_createElement(PersonWithMeetingAvailabilityMultiSearch, Object.assign({}, provided, { ids: currentDependencies.people, key: currentDependencies.people.join("-"), placeholder: showStaffNames ? undefined : "Name provided upon confirmation", forceEmptyReturn: !!errorMessage }))), helpText: !showStaffNames
                                ? "Staff for this service will be selected randomly from those available in the selected time"
                                : undefined, disabled: !showStaffNames }) }), _jsx("div", { className: "col-6", children: _jsx(SearchField, { label: "How do you want to meet?", name: "modalities", as: (provided) => (_createElement(MeetingModalityMultiSearch, Object.assign({}, provided, { active: true, ids: currentDependencies.modalities, key: currentDependencies.modalities.join("-"), forceEmptyReturn: !!errorMessage }))) }) })] }), _jsxs("div", { className: "d-flex justify-content-end", children: [_jsx(SaveButton, { isLoading: slotsState.isLoading, onClick: () => { var _a; return (_a = saveButtonRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, overrideLabel: "Find a time", disabled: !!errorMessage }), _jsx("button", { className: "btn btn-outline-secondary ml-2", onClick: () => {
                            reset({
                                staff: [],
                                offices: [],
                                modalities: [],
                                offering: null,
                                locations: [],
                            });
                        }, children: "Clear" })] })] }));
};
const AppointmentCampaignDetails = ({ appointmentCampaign, }) => {
    return (_jsxs(_Fragment, { children: [_jsx(AlertInfo, { message: _jsxs(_Fragment, { children: ["There are restrictions on scheduling this appointment.", _jsx("button", { className: "btn btn-link p-0 ml-1 alert-link", "data-toggle": "collapse", "data-target": "#appointmentInfo", "aria-expanded": "false", "aria-controls": "collapseExample", children: "More info" })] }) }), _jsx("div", { className: "collapse", id: "appointmentInfo", children: _jsx(CustomCard, { noShadow: true, className: "mb-3", children: _jsx("div", { className: "card-body", children: _jsx("div", { className: "row", children: AppointmentCampaignInfoDomainService.getInfoTextFieldsForMeetingSchedulerAppointmentCampaign(appointmentCampaign).map((info, i) => (_jsx("div", { className: "col-6", children: _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "appointment-info-" + i, children: info.label }), _jsx("div", { id: "appointment-info-" + i, children: info.value })] }) }, i))) }) }) }) })] }));
};
const PickerModal = (_a) => {
    var { slot, service, studentId, formSelections, showStaffNames } = _a, modalProps = __rest(_a, ["slot", "service", "studentId", "formSelections", "showStaffNames"]);
    if (slot.staffOfficeModalities.length === 1) {
        const slotSingleOption = slot.staffOfficeModalities[0];
        return (_jsx(Redirect, { to: getMeetingsConfirmationPath({
                confirmationSearchParams: {
                    serviceId: service.id,
                    officeId: parseInt(slotSingleOption[1].toString(), 10),
                    staffId: slotSingleOption[0].toString(),
                    startTime: slot.from,
                    endTime: slot.to,
                    modalityId: slotSingleOption[2],
                    studentId,
                },
            }), push: true }));
    }
    return (_jsxs(Modal, Object.assign({}, modalProps, { children: [_jsx(ModalHeader, { title: "Select Meeting" }), _jsxs("div", { className: "modal-body", children: [_jsx("div", { className: "mb-3", children: _jsx(InfoItems, { numColumnsLg: 3, items: [
                                {
                                    label: "Date",
                                    value: DateService.displayLong(slot.from),
                                },
                                {
                                    label: "Time",
                                    value: (_jsxs("div", { children: [DateService.displayJustTime(slot.from), " \u2013", " ", DateService.displayJustTime(slot.to)] })),
                                },
                                { label: "Service", value: service.name },
                            ] }) }), _jsxs("table", { className: "table", children: [_jsx("thead", { children: _jsxs("tr", { children: [showStaffNames && _jsx("th", { children: "Staff" }), _jsx("th", { children: "Location" }), _jsx("th", { children: "How to Meet" })] }) }), _jsx(HierarchicalTableBody, { hiddenColumn: showStaffNames ? undefined : 0, elements: slot.staffOfficeModalities, renderers: [
                                    ({ val: staffId, provided }) => {
                                        const staff = slot.staff.find((s) => s.personId === staffId);
                                        let content;
                                        if (!staff) {
                                            content = "Error finding this staff member";
                                        }
                                        else {
                                            content = (_jsxs("div", { className: "d-flex align-items-center", children: [_jsx(ProfilePicture, { person: staff, size: 30, showProfilePicture: true, className: "mr-2" }), staff.fullName] }));
                                        }
                                        return (_jsx("td", Object.assign({}, provided, { style: { verticalAlign: "middle" }, children: content })));
                                    },
                                    ({ val: officeId, provided }) => {
                                        const office = slot.offices.find((o) => o.id === officeId);
                                        let content;
                                        if (!office) {
                                            content = "Error finding this office";
                                        }
                                        else {
                                            content = `${office.location.name} - ${office.name}`;
                                        }
                                        return (_jsx("td", Object.assign({}, provided, { style: { verticalAlign: "middle" }, children: content })));
                                    },
                                    ({ val: modalityId, provided, otherOptions }) => {
                                        const modality = slot.modalities.find((m) => m.id === modalityId);
                                        let content;
                                        if (!modality || !otherOptions) {
                                            content = `Error finding this way of meeting ${modalityId}`;
                                        }
                                        else {
                                            content = (_jsxs("div", { className: "d-flex align-items-center justify-content-between", children: [modality.name, _jsx(Link, { to: getMeetingsConfirmationPath({
                                                            confirmationSearchParams: {
                                                                serviceId: service.id,
                                                                officeId: parseInt(otherOptions[1].toString(), 10),
                                                                staffId: ListService.getRandomFromList(otherOptions[0]).toString(),
                                                                startTime: slot.from,
                                                                endTime: slot.to,
                                                                modalityId,
                                                                studentId,
                                                            },
                                                        }), className: "btn btn-sm btn-primary", children: "Select" })] }));
                                        }
                                        return (_jsx("td", Object.assign({}, provided, { style: { verticalAlign: "middle", minWidth: 170 }, children: content })));
                                    },
                                ] })] })] })] })));
};
const SLOT_HEADERS = {
    Morning: [0, 12],
    Afternoon: [12, 16],
    Evening: [16, 24],
};
const Slots = ({ slots, emptyMessage, service, studentId, formSelections, isStaff, }) => {
    const slotsGroupedByDay = ListService.groupByString(slots, (s) => DateService.displayLong(DateService.getStartOfDay(s.from)));
    const [isPickerModalOpen, setIsPickerModalOpen] = useState(false);
    const [selectedSlot, setSelectedSlot] = useState(null);
    if (slots.length === 0) {
        return (_jsx("div", { className: "d-flex justify-content-center align-items-center h-100 w-100 font-weight-bold", children: emptyMessage }));
    }
    // Determines if we display staff names by checking if the service allows viewing
    // staff names or if the current user is a staff member. This is so staff
    // members can easily schedule meetings for students and allows staff members
    // to bypass the service staff selection restriction
    const showStaffNames = service.showStaffNames || isStaff;
    return (_jsxs(_Fragment, { children: [selectedSlot != null && (_jsx(PickerModal, { isOpen: isPickerModalOpen, slot: selectedSlot, onModalClosed: () => setIsPickerModalOpen(false), service: service, size: "lg", studentId: studentId, formSelections: formSelections, showStaffNames: showStaffNames })), Object.entries(slotsGroupedByDay).map(([header, groupedSlots], i) => {
                return (_jsxs("div", { className: "mb-4", children: [_jsx("div", { className: "h4 mb-3", children: header }), _jsx("div", { children: Object.entries(SLOT_HEADERS).map(([timeHeader, timeRange], j) => {
                                const slotsInTime = groupedSlots
                                    .filter((slot) => slot.from.getHours() >= timeRange[0] &&
                                    slot.from.getHours() < timeRange[1])
                                    .sort((a, b) => a.from.getTime() - b.from.getTime());
                                if (slotsInTime.length === 0) {
                                    return null;
                                }
                                return (_jsxs("div", { className: "clickable", children: [_jsx("div", { className: "font-weight-200 mt-3 mb-2", children: timeHeader }), _jsx("div", { className: "row", children: slotsInTime.map((slot, si) => (_jsx("div", { className: "col-12 col-md-4 col-lg-3 mb-2", children: _jsx(Slot, { slot: slot, onSelect: () => {
                                                        setSelectedSlot(slot);
                                                        setIsPickerModalOpen(true);
                                                    }, showStaffNames: showStaffNames }) }, si))) })] }, j));
                            }) }), i !== Object.entries(slotsGroupedByDay).length - 1 && _jsx("hr", {})] }, i));
            })] }));
};
const Slot = ({ slot, onSelect, showStaffNames, }) => (_jsx(DefaultPopover, { popoverBehavior: "hover", isOpen: true, popoverContent: _jsx("div", { children: _jsx("table", { className: "table table-sm mb-0 ", children: _jsxs("tbody", { children: [showStaffNames && (_jsxs("tr", { children: [_jsx("th", { className: "border-top-0", children: "Staff:" }), _jsx("td", { className: "border-top-0", children: ListService.displayWithCommasAndOr(slot.staff.map((p) => p.fullName), 5) })] })), _jsxs("tr", { children: [_jsx("th", { className: classNames({
                                    "border-top-0": !showStaffNames,
                                }), children: "Locations:" }), _jsx("td", { className: classNames({
                                    "border-top-0": !showStaffNames,
                                }), children: _jsxs("ul", { className: "list-group list-group-flush bg-none", children: [slot.offices.slice(0, 3).map((o) => (_jsx("li", { style: { background: "transparent" }, className: "list-group-item p-1", children: `${o.name}, ${o.location.name}` }, o.id))), slot.offices.length > 3 && (_jsxs("li", { style: { background: "transparent" }, className: "list-group-item p-1", children: ["and ", NumberService.format(slot.offices.length - 3), " other", slot.offices.length - 3 === 1 ? "" : "s"] }))] }) })] }), _jsxs("tr", { children: [_jsx("th", { style: { width: 120 }, children: "Ways To Meet:" }), _jsx("td", { children: ListService.displayWithCommasAndOr(slot.modalities.map((m) => m.name), 5) })] })] }) }) }), config: {
        popoverPadding: 2,
        popoverMaxWidth: 400,
        transitionDuration: 100,
    }, children: (provided) => (_jsxs(CustomCard, Object.assign({ tabIndex: 0, role: "button", noShadow: true, className: "rounded-lg meeting-scheduler-slot" }, provided.popoverProps, A11yHelpers.onClickOrEnterOrSpace(() => {
        onSelect === null || onSelect === void 0 ? void 0 : onSelect();
    }), { children: [_jsxs("div", { className: "sr-only", children: [DateService.displayJustTime(slot.from), " to", " ", DateService.displayJustTime(slot.to), ". Available Staff:", " ", ListService.displayWithCommasAndAnd(slot.staff.map((p) => p.fullName), 5), ". Available Locations:", " ", ListService.displayWithCommasAndOr(slot.offices.map((o) => `${o.name}, ${o.location.name}`)), ". Available Ways to Meet:", " ", ListService.displayWithCommasAndOr(slot.modalities.map((m) => m.name), 5)] }), _jsxs("div", { className: "py-2 px-1 d-flex align-items-center justify-content-center", "aria-hidden": true, children: [DateService.displayJustTime(slot.from), _jsxs("small", { className: "text-muted", children: ["\u00A0\u2013 ", DateService.displayJustTime(slot.to)] })] })] }))) }));
const SchedulerContent = (props) => {
    const [formSelections, setFormSelections] = useState({
        staff: [],
        service: null,
        offices: [],
        modalities: [],
        campuses: [],
        monthIndex: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
        afterDayInMonth: new Date().getDate(),
        from: null,
        to: null,
    });
    const [historyFormSelections, setHistoryFormSelections] = useHistoryState("formState", {
        modalities: null,
        offering: null,
        offices: null,
        locations: null,
        staff: null,
    });
    const [slotsState, getSlots] = useService((search, { minDate, maxDate, monthIndex, year, afterDayInMonth, }) => __awaiter(void 0, void 0, void 0, function* () {
        // if a minDate or a maxDate is provided, we switch to specifying dates
        // instead of months, but we still work within the month and year specified
        // in the form selections.
        let timeComponentOfGetSlots = {
            monthIndex,
            afterDayInMonth,
            year,
        };
        if (minDate || maxDate) {
            const startOfMonth = moment(new Date(formSelections.year, monthIndex - 1, 1)).startOf("month");
            const endOfMonth = moment(startOfMonth).endOf("month");
            const calendarIsInRange = (minDate == null || moment(minDate).isBefore(endOfMonth)) &&
                (maxDate == null || moment(maxDate).isAfter(startOfMonth));
            if (!calendarIsInRange) {
                return [];
            }
            const minDateInSelectedMonth = minDate != null &&
                minDate.getMonth() === formSelections.monthIndex - 1;
            const maxDateInSelectedMonth = maxDate != null &&
                maxDate.getMonth() === formSelections.monthIndex - 1;
            if (!minDateInSelectedMonth && !maxDateInSelectedMonth) {
                timeComponentOfGetSlots = {
                    monthIndex: formSelections.monthIndex,
                    afterDayInMonth: formSelections.afterDayInMonth,
                    year: formSelections.year,
                };
            }
            else if (minDateInSelectedMonth && !maxDateInSelectedMonth) {
                timeComponentOfGetSlots = {
                    monthIndex,
                    afterDayInMonth: Math.max(afterDayInMonth !== null && afterDayInMonth !== void 0 ? afterDayInMonth : 0, minDate === null || minDate === void 0 ? void 0 : minDate.getDate()),
                    year: formSelections.year,
                };
            }
            else if (!minDateInSelectedMonth && maxDateInSelectedMonth) {
                timeComponentOfGetSlots = {
                    from: new Date(year, monthIndex - 1, 0),
                    to: maxDate,
                };
            }
            else {
                // The only option left is if the max and min dates are in the current month.
                timeComponentOfGetSlots = {
                    from: minDate,
                    to: maxDate,
                };
            }
        }
        const resp = yield MeetingAvailabilityService.getSlots(Object.assign(Object.assign({}, search), timeComponentOfGetSlots));
        resp.sort((a, b) => a.from.getTime() - b.from.getTime());
        // Set current form selections to the browser history to help with navigation
        setHistoryFormSelections({
            offering: formSelections.service,
            locations: formSelections.campuses,
            offices: formSelections.offices,
            staff: formSelections.staff,
            modalities: formSelections.modalities,
        });
        return resp;
    }));
    useShallowCompareEffect(() => {
        if (formSelections.service) {
            getSlots({
                serviceOfferingId: formSelections.service.id,
                serviceDeliveryLocationIds: ListService.returnNullIfEmpty(formSelections.offices)
                    ? formSelections.offices.map((o) => o.id)
                    : props.dependencies.offices,
                staffIds: ListService.returnNullIfEmpty(formSelections.staff)
                    ? formSelections.staff.map((s) => s.personId)
                    : props.dependencies.people,
                meetingModalityIds: ListService.returnNullIfEmpty(formSelections.modalities)
                    ? formSelections.modalities.map((m) => m.id)
                    : props.dependencies.modalities,
                campusIds: ListService.returnNullIfEmpty(formSelections.campuses)
                    ? formSelections.campuses.map((c) => c.id)
                    : props.dependencies.campuses,
            }, {
                minDate: props.minDate,
                maxDate: props.maxDate,
                monthIndex: formSelections.monthIndex,
                afterDayInMonth: formSelections.afterDayInMonth,
                year: formSelections.year,
            });
        }
    }, [
        formSelections,
        getSlots,
        props.dependencies.modalities,
        props.dependencies.offices,
        props.dependencies.people,
        props.maxDate,
        props.minDate,
    ]);
    const [date, setDate] = useState(moment());
    // whenever the slots change, if our selected date is out of range, pick the first date available
    useEffect(() => {
        if (slotsState.data && slotsState.data.length !== 0) {
            const slots = slotsState.data;
            const min = moment(slots[0].from).startOf("day");
            const max = moment(slots[slots.length - 1].to).endOf("day");
            if (!moment(date).isBetween(min, max, "day", "[]")) {
                setDate(min);
            }
        }
    }, [date, slotsState.data]);
    const saveButtonRef = React.useRef(null);
    const [dependencyErrorMessage, setDependencyErrorMessage] = useState(null);
    const filteredSlots = React.useMemo(() => {
        const selectedDate = moment(date).startOf("day");
        const lastDateAfterSelectedDate = moment(selectedDate)
            .add(2, "days")
            .endOf("day");
        if (slotsState.data == null || slotsState.data.length === 0) {
            return [];
        }
        const slots = slotsState.data;
        // if the selected date is earlier than the first slot or later than the last slot, return nothing
        if (lastDateAfterSelectedDate.endOf("day").unix() * 1000 <
            slots[0].from.getTime() ||
            selectedDate.startOf("day").unix() * 1000 >
                slots[slots.length - 1].to.getTime()) {
            return [];
        }
        // FYI we don't handle date ranges spanning multiple months
        return slots.filter((s) => moment(s.from).isSameOrAfter(selectedDate) &&
            moment(s.to).isBefore(lastDateAfterSelectedDate));
    }, [date, slotsState.data]);
    return (_jsxs(_Fragment, { children: [_jsxs(BasicFormFormat, { defaultValue: () => __awaiter(void 0, void 0, void 0, function* () {
                    var _a, _b, _c, _d, _e;
                    if (props.searchParams) {
                        const stableSearchParams = yield parseSearchParamsToDefaultValues(props.searchParams);
                        return Object.assign(Object.assign({}, stableSearchParams), { offering: (_a = historyFormSelections.offering) !== null && _a !== void 0 ? _a : stableSearchParams.offering, locations: (_b = historyFormSelections.locations) !== null && _b !== void 0 ? _b : stableSearchParams.locations, offices: (_c = historyFormSelections.offices) !== null && _c !== void 0 ? _c : stableSearchParams.offices, staff: (_d = historyFormSelections.staff) !== null && _d !== void 0 ? _d : stableSearchParams.staff, modalities: (_e = historyFormSelections.modalities) !== null && _e !== void 0 ? _e : stableSearchParams.modalities });
                    }
                    return historyFormSelections;
                }), handleSubmit: (form) => __awaiter(void 0, void 0, void 0, function* () {
                    setFormSelections((fs) => {
                        var _a, _b, _c, _d;
                        return (Object.assign(Object.assign({}, fs), { staff: (_a = form.staff) !== null && _a !== void 0 ? _a : [], service: form.offering, offices: (_b = form.offices) !== null && _b !== void 0 ? _b : [], modalities: (_c = form.modalities) !== null && _c !== void 0 ? _c : [], campuses: (_d = form.locations) !== null && _d !== void 0 ? _d : [] }));
                    });
                }), saveButtonRef: saveButtonRef, errorMessagePosition: "bottom", disableSaveButton: !!dependencyErrorMessage, hideButtons: true, showRequiredFieldsHelpText: true, children: [_jsx(MeetingDependencyForm, { initialDependencies: props.dependencies, setDependencyErrorMessage: setDependencyErrorMessage, saveButtonRef: saveButtonRef, slotsState: slotsState, isCurrentUserStaff: props.isCurrentUserStaff }), dependencyErrorMessage && (_jsx(AlertError, { className: "mt-2", message: dependencyErrorMessage }))] }), (slotsState.isLoading ||
                slotsState.wasSuccessful ||
                slotsState.hasError) && _jsx("hr", { className: "mb-5" }), _jsx(ServiceResult, { state: slotsState, loader: Loaders.overlay(), children: (slots) => {
                    var _a;
                    return (_jsxs("div", { className: "row", children: [_jsx("div", { className: "col-12 col-lg-4", children: _jsx("center", { children: _jsx(MeetingSchedulerCalendar, { highlightedDates: ListService.unique(slots.map((s) => DateService.getStartOfDay(s.from)), (d) => d.getTime()), value: date, onChange: setDate, onMonthChange: (newMonth, newYear) => {
                                            setFormSelections((fs) => (Object.assign(Object.assign({}, fs), { monthIndex: newMonth, 
                                                // if the newMonth is the current month, don't fetch slots for the entire month.  Just today and after
                                                afterDayInMonth: newMonth === new Date().getMonth() + 1
                                                    ? new Date().getDate()
                                                    : null, year: newYear })));
                                        } }) }) }), _jsx("div", { className: "col-12 col-lg-8 mt-lg-0 mt-5", children: formSelections.service && (_jsx(Slots, { slots: filteredSlots, service: formSelections.service, studentId: (_a = props.searchParams) === null || _a === void 0 ? void 0 : _a.studentId, emptyMessage: `No available times in ${new Date(0, formSelections.monthIndex - 1).toLocaleString("default", {
                                        month: "long",
                                    })}.`, formSelections: formSelections, isStaff: props.isCurrentUserStaff })) })] }));
                } })] }));
};
const MeetingScheduleComponent = (props) => {
    const [meetingDependencyState, getMeetingDependencies] = useService(MeetingAvailabilityService.getDependencyList);
    const [appointmentCampaignState, getAppointmentCampaignInfo] = useService((id) => __awaiter(void 0, void 0, void 0, function* () {
        if (!id) {
            return null;
        }
        return CampaignService.getAppointmentCampaignLiteInfo(id);
    }));
    useEffect(() => {
        getAppointmentCampaignInfo(props.searchParams.campaignId);
        getMeetingDependencies(props.searchParams.campaignId);
    }, [
        getAppointmentCampaignInfo,
        getMeetingDependencies,
        props.searchParams.campaignId,
    ]);
    const [isStaffState, loadIsStaff] = useService(RoleService.currentUserIsStaff);
    React.useEffect(() => {
        loadIsStaff();
    }, [loadIsStaff]);
    return (_jsx(ContentLayout, { paddingTop: true, notFluid: true, paddingBottom: true, className: "fullMinHeightMinusPrimaryNav", children: _jsx(CustomCard, { className: "mt-4", title: "Schedule A Meeting", children: _jsx("div", { className: "card-body", children: _jsx("div", { className: "mb-4", children: _jsx(ServiceResult, { state: appointmentCampaignState, stillRenderChildWhenNoData: true, children: (appointmentCampaign) => (_jsxs(_Fragment, { children: [appointmentCampaign && (_jsx(AppointmentCampaignDetails, { appointmentCampaign: appointmentCampaign })), _jsx(ServiceResult, { state: meetingDependencyState, children: (dependencies) => (_jsx(ServiceResult, { state: isStaffState, children: (isStaff) => (_jsx(SchedulerContent, { dependencies: dependencies, searchParams: props.searchParams, minDate: appointmentCampaign === null || appointmentCampaign === void 0 ? void 0 : appointmentCampaign.startDate, maxDate: appointmentCampaign === null || appointmentCampaign === void 0 ? void 0 : appointmentCampaign.endDate, isCurrentUserStaff: isStaff })) })) })] })) }) }) }) }) }));
};
const MeetingSchedule = () => {
    const params = useParams();
    const safeSearchParams = MEETINGS_SCHEDULE_SEARCH_PARAMS.safeParse(params);
    if (!safeSearchParams.success) {
        return (_jsx(ContentLayout, { notFluid: true, paddingBottom: true, paddingTop: true, className: "fullMinHeightMinusPrimaryNav", children: _jsx(AlertError, { message: "Invalid request" }) }));
    }
    return (_jsx(ContentLayout, { notFluid: true, paddingBottom: true, paddingTop: true, className: "fullMinHeightMinusPrimaryNav", children: _jsx(MeetingScheduleComponent, { searchParams: safeSearchParams.data }) }));
};
export default MeetingSchedule;
